import React, { useCallback } from 'react';
import styles from './FlowRunsWidget.module.scss';
import { Stack, Typography } from '@mui/material';
import cx from 'classnames';
import { ReactComponent as RefreshIcon } from 'new/components/icons/fi-rr-refresh.svg';
import { ReactComponent as RefreshIconRotate } from 'new/components/icons/fi-rr-refresh-rotate.svg';
import { ReactComponent as ClockIcon } from 'new/components/icons/fi-rr-clock.svg';
import { ReactComponent as PlayIcon } from 'new/components/icons/fi-rr-play-alt.svg';
import { useFlowRunsTable } from 'new/components/monitor/Runs/hooks/useFlowRuns';
import { FlowRunItem } from './FlowRunItem';
import { FlowRunItemSkeleton } from './FlowRunItemSkeleton';

export const FlowRunsWidget = () => {
  const [state, { refresh: refreshFlowRuns }] = useFlowRunsTable();
  const { data, loading } = state;

  const onRefresh = useCallback(() => {
    refreshFlowRuns({ page: 1 });
  }, [refreshFlowRuns]);

  return (
    <div className={styles.flowRunsWidget}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="column" gap="var(--spacing-sm)">
          <Typography variant="subtitle1" className={styles.flowRunsTitle}>
            Flow Runs
          </Typography>
          <Stack direction="row" alignItems="center" gap="var(--spacing-sm)">
            <ClockIcon className={styles.clockIcon} />
            <Typography variant="body2" className={styles.recentRunsTitle}>
              Recent activity
            </Typography>
          </Stack>
        </Stack>
        {loading ? (
          <RefreshIconRotate
            fontSize="large"
            className={cx('refreshIcon', styles.runsRefreshIcon)}
          />
        ) : (
          <RefreshIcon
            onClick={onRefresh}
            fontSize="large"
            className={cx('refreshIcon', styles.runsRefreshIcon)}
          />
        )}
      </Stack>
      {loading ? (
        <Stack direction="column" gap="var(--spacing-lg)">
          {Array.from({ length: 6 }).map((_, index) => (
            <FlowRunItemSkeleton key={`skeleton-${index}`} />
          ))}
        </Stack>
      ) : data.length === 0 ? (
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          gap="var(--spacing-lg)"
          className={styles.noRunsContainer}
        >
          <PlayIcon />
          <Typography variant="bodyLarge" className={styles.noRunsTitle}>
            No recent runs
          </Typography>
        </Stack>
      ) : (
        <Stack direction="column" gap="var(--spacing-lg)" className={styles.runsListContainer}>
          {data.map((run: any) => (
            <FlowRunItem key={run?.id || run?.run_id} run={run} />
          ))}
        </Stack>
      )}
    </div>
  );
};
